<template>
  <div class="newAddKS">
    <el-form :model="ExamForm" :rules="rules" ref="ExamForm">
      <el-form-item
        label="考生账号："
        :label-width="formLabelWidth"
        prop="userName"
      >
        <el-input
          :disabled="this.isEdit"
          v-model.trim="ExamForm.userName"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="考生姓名："
        :label-width="formLabelWidth"
        prop="realName"
      >
        <el-input
          v-model.trim="ExamForm.realName"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="科室："
        :label-width="formLabelWidth"
        prop="DepartmentName"
      >
        <!-- <div v-for="items in options_ks" :key="items.DepartmentID">
          <div>{{items.DepartmentID}}</div>
          <div>{{items.DepartmentName}}</div>
        </div> -->
        <el-select v-model="ExamForm.DepartmentName" placeholder="请选择科室">
          <el-option
            v-for="item in options_ks"
            :key="item.DepartmentID"
            :label="item.DepartmentName"
            :value="item.DepartmentName"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="登录密码："
        :label-width="formLabelWidth"
        prop="pwd"
        v-if="!this.isEdit"
      >
        <el-input
          v-model.trim="ExamForm.pwd"
          autocomplete="off"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item label="职称：" :label-width="formLabelWidth">
        <!-- <div v-for="items in options_zc" :key="items.pTitleID">
          <div>{{items.pTitleID}}</div>
          <div>{{items.PTitle}}</div>
        </div> -->
        <el-select v-model="ExamForm.PTitle" placeholder="请选择职称">
          <el-option
            v-for="item in options_zc"
            :key="item.pTitleID"
            :label="item.PTitle"
            :value="item.PTitle"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="职位：" :label-width="formLabelWidth">
        <el-select v-model="ExamForm.Position" placeholder="请选择职位">
          <el-option
            v-for="item in options_zw"
            :key="item.PositionID"
            :label="item.Position"
            :value="item.Position"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="出生年月：" :label-width="formLabelWidth">
        <div class="block">
          <el-date-picker
            v-model="ExamForm.Birthday"
            type="date"
            placeholder="请选择日期"
            format="yyyy年-MM月-dd日"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="入职日期：" :label-width="formLabelWidth">
        <div class="block">
          <el-date-picker
            v-model="ExamForm.job"
            type="date"
            placeholder="请选择日期"
            format="yyyy年-MM月-dd日"
          >
          </el-date-picker>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="onCancel('ExamForm')">取 消</el-button>
      <el-button type="primary" @click="onSubmit('ExamForm')">确 定</el-button>
    </div>
  </div>
</template>

<script>
import {
  getSectionList,
  getPTitleList,
  getPositionList,
  updateStudent,
} from "@/services/examManager.js";
export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    // 校验非空
    var validateIsNull = (rule, value, callback, prefixMsg) => {
      if (value instanceof Array) {
        value = value.join("");
      }
      if (value.split(" ").join("").length === 0) {
        callback(new Error(prefixMsg + "不能为空"));
      } else {
        callback();
      }
    };
    return {
      ExamForm: {
        userName: "",
        realName: "",
        pwd: "",
        PTitle: "",
        job: "",
        Birthday: "",
        Position: "",
        DepartmentName: "",
      },
      // 科室
      options_ks: [],
      // 职称
      options_zc: [],
      // 职位
      options_zw: [],
      formLabelWidth: "120px",
      // 新增考生对象
      examAddObj: {},
      rules: {
        userName: [
          { required: true, message: "请输入考生账号", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              validateIsNull(rule, value, callback, "考生账号");
            },
            trigger: "blur",
          },
        ],
        realName: [
          { required: true, message: "请输入考生姓名", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              validateIsNull(rule, value, callback, "考生姓名");
            },
            trigger: "blur",
          },
          { min: 1, max: 5, message: "长度在 1 到 5 个字符", trigger: "blur" },
        ],
        DepartmentName: [
          { required: true, message: "请输入科室名称", trigger: "change" },
          {
            validator: (rule, value, callback) => {
              validateIsNull(rule, value, callback, "科室名称");
            },
            trigger: "blur",
          },
        ],
        pwd: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              validateIsNull(rule, value, callback, "登录密码");
            },
            trigger: "blur",
          },
          { min: 6, message: "长度在 至少5 个字符", trigger: "blur" },
        ],
      },
      pickerOptions: {
        disabledDate(date) {
          //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          //禁用当天之后不包括今天 date.getTime() > Date.now() - 24 * 60 * 60 * 1000
          //禁用当天之前不包括今天 date.getTime() > Date.now()
          return date.getTime() > Date.now();
        },
      },
    };
  },
  methods: {
    // 取消
    onCancel(formName) {
      // 设置取消状态，让父组件处理
      this.$emit("cancel");
      this.$refs[formName].resetFields();
      this.ExamForm = {};
    },
    // 添加考生表单提交
    onSubmit(formName) {
      // 新增的时候
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.modifyExamInfo();
        }
      });
    },

    // 封装方法
    UtilFun(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },
    // 获取科室数据
    async getSectionData() {
      const sectionObj = new Object();
      this.UtilFun(sectionObj);
      const { data } = await getSectionList(sectionObj);
      if (data.Status === 200) {
        // console.log(data, "科室下拉列表数据");
        this.options_ks = data.Data;
      }
    },
    // 获取职称数据
    async getPTitleData() {
      const sectionObj = new Object();
      this.UtilFun(sectionObj);
      const { data } = await getPTitleList(sectionObj);
      if (data.Status === 200) {
        // console.log(data, "职称数据");
        this.options_zc = data.Data;
        this.options_zc = this.options_zc.forEach((element, index) => {
          element.pTitleID = index;
        });
        this.options_zc = data.Data;
      }
    },
    // 获取职位数据
    async getPositionData() {
      const sectionObj = new Object();
      this.UtilFun(sectionObj);
      const { data } = await getPositionList(sectionObj);
      if (data.Status === 200) {
        // console.log(data, "职位数据");
        this.options_zw = data.Data;
        this.options_zw = this.options_zw.forEach((element, index) => {
          element.PositionID = index;
        });
        this.options_zw = data.Data;
      }
    },

    // 确定修改考生信息
    async modifyExamInfo() {
      const examInfo = {};
      this.UtilFun(examInfo);
      examInfo.JobDate = this.ExamForm.job;
      // 考生ID
      examInfo.studentUserID = this.$parent.$parent.editData[6];
      examInfo.realName = this.ExamForm.realName;
      // 科室
      // console.log(this.ExamForm.DepartmentName);
      examInfo.departmentName = this.ExamForm.DepartmentName;
      // this.options_ks.forEach((element) => {
      //   examInfo.departmentName = element.DepartmentName
      // });
      // 职称
      // console.log(this.ExamForm.PTitle);
      examInfo.PTitle = this.ExamForm.PTitle;
      // this.options_zc.forEach((element) => {
      //   examInfo.PTitle = element.PTitle;
      // });
      // 职位
      // console.log(this.ExamForm.Position);
      examInfo.Position = this.ExamForm.Position;
      // this.options_zw = this.options_zw.forEach((element) => {
      //   examInfo.Position = element.Position;
      // });
      examInfo.Birthday = this.ExamForm.Birthday;
      console.log(examInfo);
      const { data } = await updateStudent(examInfo);
      console.log(data);
      if (data.Status === 200) {
        this.$message.success("修改考生信息成功");
        // 发送消息
        this.$emit("success");
        // 清除表单内容
        this.ExamForm = {};
      } else {
        this.$message.console.error(data.Data);
      }
    },

    // 编辑数据
    editDataShow() {
      // console.log(this.$parent.$parent.editData);
      this.ExamForm.userName = this.$parent.$parent.editData[0];
      this.ExamForm.realName = this.$parent.$parent.editData[1];
      this.ExamForm.DepartmentName = this.$parent.$parent.editData[2];
      this.ExamForm.PTitle = this.$parent.$parent.editData[3];
      this.ExamForm.Position = this.$parent.$parent.editData[4];
      this.ExamForm.Birthday = this.$parent.$parent.editData[5];
      this.ExamForm.UserID = this.$parent.$parent.editData[6];
      this.ExamForm.job = this.$parent.$parent.editData[7];
      // console.log(this.$parent.$parent.editData[6]);
      // console.log(this.$parent.$parent.editData[7]);
    },
  },
  created() {
    this.getSectionData();
    this.getPTitleData();
    this.getPositionData();
    // 弹框编辑数据
    this.editDataShow();
  },
};
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
  margin-top: 50px;
  .el-button:nth-child(1) {
    background: #eeeeee;
    opacity: 1;
    border-radius: 4px;
  }
  .el-button:nth-child(2) {
    background: #1890ff;
    opacity: 1;
    border-radius: 4px;
  }
}

.el-form {
  display: flex;
  flex-direction: column;
}
</style>